function AdminSummary({ isSuperAdmin, loading, onRefresh }) {
  return (
    <div className="admin-summary">
      <div>
        <p className="admin-kicker">{isSuperAdmin ? "최고관리자 전용" : "회사 관리자 전용"}</p>
        <h2>관리자 대시보드</h2>
        <p>
          {isSuperAdmin
            ? "전체 회사, 회원, Agent 작업, 코드 변경, 감사 로그를 관리합니다."
            : "소속 회사의 회원, 활동량, 운영 상태를 관리합니다."}
        </p>
      </div>
      <button onClick={onRefresh} disabled={loading} className="admin-refresh-button">
        {loading ? "확인 중" : "새로고침"}
      </button>
    </div>
  );
}

export default AdminSummary;
